// Single source of truth for the FavoTrip huisstijl dash rule.
//
// Dennis 2026-05-24: CMS/partner copy pasted from Word/Google Docs drags along
// figure-dash (U+2012), en-dash (U+2013), em-dash (U+2014), horizontal-bar
// (U+2015) and mathematical minus-sign (U+2212). These read as typographic
// noise in Dutch marketing copy - the huisstijl is a plain ASCII hyphen-minus
// (U+002D). The plain ASCII hyphen is preserved so compound words
// (all-inclusive, zelf-service) stay intact.
//
// The deal-quality C5 content gate fails any live deal/voucher page whose
// rendered NL text carries one of these dashes. sanitizeHtml already folds them
// on the rich-HTML path; this dependency-free helper lets the plain-text render
// path (titles, names, hotel names via stripInlineHtml) share the exact same
// rule without pulling DOMPurify into every bundle.
export const FORBIDDEN_DASH_RE = /[‒–—―−]/g;

export function foldTypographicDashes(value) {
  return typeof value === "string" ? value.replace(FORBIDDEN_DASH_RE, "-") : value;
}
